<template>
  <div>
    <el-card>
      <el-alert title="产品展示" type="info" center show-icon :closable='false'> </el-alert>

      <div class="product_container">

        <div class="product_text">
          <h3 v-if="isEdit">编辑产品展示</h3>
          <h3 v-else>添加产品展示</h3>
          <el-button size="mini" class="btn" @click="goProductList">返回</el-button>
        </div>

        <el-form :model="productForm" label-width="90px" label-position="top" class="product_form">
          <el-form-item label="产品图:">
            <div class="mediaRow">
              <div class="mediaBlock">
                <!-- 产品图封面 -->
                <div style="width: 300px;height: 40px;"><el-button v-if="coverUrl != '' && coverUrl != null" type="primary" size="mini" @click="delCover">删除</el-button></div>
                <div class="coverImg">
                  <div class="backgroundImg" v-if="coverUrl != '' && coverUrl != null">
                    <img class="coverPreviewImg" :src="coverUrl" alt="">
                  </div>
                  <el-upload
                    class="coverUpload"
                    v-else
                    action="string"
                    list-type="picture-card"
                    :http-request="uploadCover"
                    accept=".png,.jpg,.jpeg"
                    :show-file-list="false">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
                <div class="uploadTip">建议上传比例：4:3（宽:高）</div>
              </div>

              <div class="mediaBlock videoBlock">
                <!-- 产品视频 -->
                <div style="width: 300px;height: 40px;"><el-button v-if="videoURL != '' && videoURL != null" type="primary" size="mini" @click="delVideo">删除</el-button></div>
                <div class="coverImg">
                  <div class="backgroundImg" v-if="videoURL != '' && videoURL != null">
                    <video class="videoPreview" :src="videoURL" controls></video>
                  </div>
                  <el-upload
                    class="coverUpload"
                    v-else
                    action="string"
                    list-type="picture-card"
                    :http-request="uploadVideo"
                    accept=".mp4"
                    :show-file-list="false">
                    <i class="el-icon-plus"></i>
                  </el-upload>
                </div>
                <div class="uploadTip">建议上传格式：MP4</div>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="产品名称:" prop="title">
            <!-- 产品题目 -->
            <el-input v-model="productForm.name"></el-input>
          </el-form-item>

          <el-form-item label="产品系列:">
            <el-select v-model="productForm.seriesId" filterable placeholder="请选择">
              <el-option
                v-for="item in seriesList"
                :key="item.id"
                :label="item.name"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>

          <!-- 产品内容富文本 -->
          <el-form-item label="产品参数:" prop="content">
            <!-- 产品内容 富文本组件-->
            <quill-editor-component type="product" uploadImgId="uploadImgId3" uploadVideoId="uploadVideoId3" ref="quillEditorRef"></quill-editor-component>
          </el-form-item>

          <el-form-item class="btns">
            <el-button v-if="!isEdit" type="primary" @click="addProduct" :loading="isAdd">添加</el-button>
            <el-button v-else type="primary" @click="addProduct" :loading="isAdd">编辑</el-button>
            <el-button @click="resetProductForm">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { uploadCover, delCover, deleteProductMedia, getAdminSeriesList, getProductContent, addProduct, updateProductContent, uploadProductMedia } from '@/api/editProducts'
import quillEditorComponent from '../../components/quillEditorComponent.vue'
export default {
  components: {
    quillEditorComponent
  },
  data () {
    return {
      // 产品表单
      productForm: {
        coverURL: '',
        videoURL: '',
        id: null,
        content: '',
        name: '',
        seriesId: null
      },
      // 添加按钮样式
      isAdd: false,
      // 判断编辑还是添加  默认添加
      isEdit: false,
      // 取消编辑时 删除正在编辑中多出来的图片或视频 或 删除添加模式中的图片或视频
      productRemoveFileIdList: [],
      coverUrl: '', // 产品图
      videoURL: '', // 产品视频
      seriesList: []// 系列
    }
  },
  created () {
    if (this.$route.params.id != undefined) {
      // 编辑状态
      this.isEdit = true
      // 获取编辑的内容
      this.getProductContent(this.$route.params.id)
      this.productForm.id = Number(this.$route.params.id)
    } else {
      this.isEdit = false
    }
    this.getProductSeriesList()
  },
  methods: {
    // 上传产品图
    uploadCover (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      uploadCover(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.coverUrl = res.data
        }
      })
    },
    // 上传产品视频
    uploadVideo (params) {
      const formData = new FormData()
      formData.append('file', params.file)
      uploadProductMedia(formData).then(res => {
        if (res.code == '-1') {
          this.$message.error('上传失败！')
        } else {
          this.videoURL = res.data.url || ''
          if (this.videoURL == '') {
            this.$message.error('上传失败！')
          }
        }
      })
    },
    // 删除产品图
    delCover () {
      if (this.isEdit == true) {
        delCover(this.productForm.id, this.coverUrl).then(res => {
          if (res.code == '-1') {
            this.$message.error('删除失败！')
          } else {
            this.coverUrl = ''
          }
        })
      } else {
        delCover(null, this.coverUrl).then(res => {
          if (res.code == '-1') {
            this.$message.error('删除失败！')
          } else {
            this.coverUrl = ''
          }
        })
      }
    },
    // 删除产品视频
    delVideo () {
      const previous = this.videoURL
      this.videoURL = ''
      if (previous) deleteProductMedia(previous)
    },
    // 获取产品系列
    getProductSeriesList () {
      getAdminSeriesList().then(res => {
        if (res.code == 0) {
          this.seriesList = res.data
        }
      })
    },
    // 获取要修改的产品参数内容
    getProductContent (id) {
      getProductContent(id).then(res => {
        if (res.code == 0) {
          this.productForm.name = res.data.name
          this.productForm.seriesId = res.data.seriesId
          this.$refs.quillEditorRef.content = res.data.content
          this.coverUrl = res.data.coverURL
          this.videoURL = res.data.videoURL || ''
        } else {
          this.$message.error('获取编辑的产品参数失败')
        }
      })
    },
    // 添加保存产品  编辑保存产品
    addProduct () {
      this.isAdd = true
      this.productForm.content = this.$refs.quillEditorRef.content
      if (this.coverUrl == '' || this.coverUrl == null) {
        this.$message.error('请上传产品图')
        this.isAdd = false
        return
      } else {
        this.productForm.coverURL = this.coverUrl
      }
      this.productForm.videoURL = this.videoURL
      // const imagesList = this.$refs.quillEditorRef.imagesList
      // 返回产品中存在和不存在的图片或视频数组
      // imagesList.filter(item =>{
      //   if(this.productForm.content.indexOf(item.url) != -1){
      //     this.productForm.addFileIdList.push(item.id)
      //   }else{
      //     this.productForm.removeFileIdList.push(item.id)
      //   }
      //   return
      // })
      if (this.productForm.name == '') {
        this.$message.error('请输入产品名称！')
        this.isAdd = false
        return
      }
      if (this.productForm.seriesId == '' || this.productForm.seriesId == null) {
        this.$message.error('请选择产品系列！')
        this.isAdd = false
        return
      }
      if (this.productForm.content == '') {
        this.$message.error('请输入产品参数！')
        this.isAdd = false
        return
      }
      if (!this.isEdit) {
        // 添加保存产品
        addProduct(this.productForm).then(res => {
          if (res.code == 0) {
            this.isAdd = false
            this.$message.success('添加成功！')
            this.resetProductForm()
            this.$router.push(this.productListRoute())
          } else {
            this.$message.error(res.msg)
            this.isAdd = false
          }
        })
      } else {
        // 编辑保存产品
        updateProductContent(this.productForm).then(res => {
          if (res.code == 0) {
            this.isAdd = false
            this.$message.success('编辑成功！')
            this.resetProductForm()
            this.$router.push(this.productListRoute())
          } else {
            this.$message.error(res.msg)
            this.isAdd = false
          }
        })
      }
    },
    // 重置
    resetProductForm () {
      this.$refs.quillEditorRef.content = ''
      this.productForm.name = ''
      this.productForm.seriesId = null
      this.productForm.coverUrl = ''
      this.productForm.videoURL = ''
      this.videoURL = ''
    },
    // 返回列表页面
    goProductList () {
      this.$router.push(this.productListRoute())
      this.resetProductForm()
      if (this.isEdit == false && this.coverUrl != '') {
        this.delCover()
      }
    },
    productListRoute () {
      return { name: 'admin-products', query: { ...this.$route.query } }
    }
  }
}
</script>

<style lang="less" scoped>
.product_container{
  margin-top: 20px;
  .product_text{
    display: flex;
    justify-content: space-between;
    h3{
      border-bottom: 2px solid #409eff;
    }
    .btn{
      border: 0;
      color: #ccc;
      font-size: 15px;
    }
  }
}
.product_form{
  margin-top: 20px;
  .btns{
    display: flex;
    justify-content: flex-end;
  }
  .mediaRow{
    display: flex;
    gap: 20px;
  }
  .mediaBlock{
    display: flex;
    flex-direction: column;
  }
  .coverImg{
    display: flex;
    .backgroundImg{
      width: 300px;
      height: 225px;
      .coverPreviewImg{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
      .videoPreview{
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
}

/deep/ .coverUpload .el-upload--picture-card{
  width: 300px;
  height: 225px;
  line-height: 225px;
}

.uploadTip{
  font-size: 12px;
  color: red;
}
</style>
